export const GET_POSTING_LAST_STEP = 'publicador-profesionales/stepper/GET_POSTING_LAST_STEP';
export const GET_POSTING_LAST_STEP_COMPLETED = 'publicador-profesionales/stepper/GET_POSTING_LAST_STEP_COMPLETED';
export const GET_POSTING_LAST_STEP_FAILED = 'publicador-profesionales/stepper/GET_POSTING_LAST_STEP_FAILED';
export const UPDATE_LAST_STEP = 'publicador-profesionales/stepper/UPDATE_LAST_STEP';
export const SET_CURRENT_STEP = 'publicador-profesionales/stepper/SET_CURRENT_STEP';
export const SET_PREVENT_TRANSITION = 'publicador-profesionales/stepper/SET_PREVENT_TRANSITION';
export const SET_NEXT_STEPPER_ROUTE = 'publicador-profesionales/stepper/SET_NEXT_STEPPER_ROUTE';
export const SET_STEPPER_FORM_REF = 'publicador-profesionales/stepper/SET_STEPPER_FORM_REF';
export const SET_SNACKBAR = 'publicador-profesionales/stepper/SET_SNACKBAR';
